<h1>Passwort ändern</h1>

<p>Das neue Passwort muss mindestens 8 Zeichen lang sein und aus mindestens einem Großbuchstaben, einem Kleinbuchstaben, einer Ziffer und einem Sonderzeichen (z.B. *, !, +, #, ?, %) bestehen.</p>

<form [formGroup]="loginForm" class="login-form" (ngSubmit)="onSubmit()">
  <div>
    <mat-form-field class="login-input">
      <input autocomplete="off" matInput placeholder="Derzeitiges Passwort" [formControl]="passwordControlOld" type="password">
      <mat-error *ngIf="passwordControlOld.hasError('required')">
        Bitte geben Sie Ihr Passwort ein
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="login-input">
      <input autocomplete="off" matInput placeholder="Neues Passwort" [formControl]="passwordControlNew1" type="password">
      <mat-error *ngIf="passwordControlNew1.hasError('required')">
        Bitte geben Sie das neue Passwort ein
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="login-input">
      <input autocomplete="off" matInput placeholder="Passwort wiederholen" [formControl]="passwordControlNew2" type="password">
      <mat-error *ngIf="passwordControlNew2.hasError('required')">
        Bitte geben Sie das neue Passwort erneut ein
      </mat-error>
    </mat-form-field>
  </div>
  <div class="submit">
    <button mat-raised-button [disabled]="loading" class="login-button">
      <mat-spinner *ngIf="loading"></mat-spinner>
      <mat-icon [class.hidden]="loading">login</mat-icon>
      Speichern
    </button>
  </div>
</form>

<div class="errors">
  <div *ngIf="errNotEqual">
    <mat-icon>perm_identity</mat-icon>
    Die Passwörter stimmen nicht überein.
  </div>
  <div *ngIf="errFailure">
    <mat-icon>close</mat-icon>
    Es ist ein Fehler aufgetreten.
  </div>
  <div *ngIf="errWeak">
    <mat-icon>close</mat-icon>
    Das neue Passwort erfüllt nicht die Anforderungen.
  </div>
  <div *ngIf="errNotAuthorized">
    <mat-icon>close</mat-icon>
    Das alte Passwort ist nicht korrekt.
  </div>
</div>
